import {Device} from "../../utils/Device";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "../../RootReducer";
import "./MobileGamePreview.scss";
import BackgroundUrlTranslator from "../../BackgroundUrlTranslator";
import React, {useEffect, useRef} from "react";
import {launch, launchMobile, mapTranslations} from "./CasinoGameThumbnail";
import Translator from "../../Translator";
import {getFilteredGames, getSelectedPageId, getStudios} from "../../selectors/casino-selectors";
import {toggleFavouriteGame} from "../CasinoActions";
import {getLoggedIn} from "../../selectors/user-selectors";
import {useHistory} from "react-router-dom";
import {CSSTransition} from "react-transition-group";
import { selectMobilePreviewGame } from "../../navigation/NavigationActions";
import { useCasinoFilterParams } from "./CasinoFilterParams";

export const MobileGamePreview = () => {
    const dispatch = useDispatch();
    const game = useSelector((app : AppState) => app.navigation.mobilePreviewGame);
    const container = useRef<HTMLDivElement>(null);
    const currentPageId = useSelector((app : AppState) => getSelectedPageId(app));
    const studios  =useSelector((app : AppState) => getStudios(app));
    const { selectedProviders: selectedStudioIds, selectedFeatures: selectedTagIds } = useCasinoFilterParams();
    const gameState = useSelector((state: AppState) => getFilteredGames(selectedStudioIds, selectedTagIds)(state)) ?? [];
    const favourite = gameState.favourites.find(f => f.id == game?.id);
    const hasPlayForFun = game?.playForFun;
    const loggedIn = useSelector((app : AppState) => getLoggedIn(app));
    const history = useHistory();
    const isMobile = useSelector((app: AppState)=> app.settings.mobile)

    const handleClick = (e : any) => {
        if(!e.target || container?.current?.contains(e.target as any)) {
            return;
        }
        dispatch(selectMobilePreviewGame(undefined));
        //e.preventDefault();
        //e.stopPropagation();
    }

    useEffect(()=>{
        let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
        document.body.style.overflow = "hidden";
        document.body.style.marginRight = scrollbarWidth + "px";
        document.addEventListener('mousedown',handleClick, false);
        document.addEventListener('touchstart',handleClick, false);
        return () => {
            dispatch(selectMobilePreviewGame(undefined));
            document.removeEventListener('mousedown',handleClick);
            document.removeEventListener('touchstart',handleClick);
            if(isMobile) {
                document.body.style.overflow = "";
                document.body.style.marginRight = "";
            }
        }
    }, [])

    if(!game){
        return <></>
    }
    let studio = studios.find(s => s.id == game.studioId);
    return (
        <CSSTransition in={true} timeout={0} classNames={"show-mobile-preview"} appear exit>
            <div className={"mobile-game-preview"} ref={container}>

              {game.imageUrl && <BackgroundUrlTranslator className={"background-image"} defaultTranslation={game.imageUrl} translations={mapTranslations(game)}/>}
                <div className={"preview-content"}>
                    <div className={"title-row"}>
                        <div className={"favourite"} onClick={()=>dispatch(toggleFavouriteGame(game, currentPageId) as any)}>
                            {!favourite &&  <a className={"favourite"}><i className={"material-icons favourite-icon"}>favorite_border</i></a>}
                            {favourite &&  <a className={"favourite selected"}><i className={"material-icons favourite-icon"}>favorite</i></a>}
                        </div>
                        <div className={"title"}>
                            <h4>
                                {game.translations && <Translator defaultTranslation={game.name} translations={game.translations.map(t=>({lng : t.language, value : t.name})) as any} />}
                                {!game.translations && game.name}
                            </h4>
                            <h5>{game && studio?.name}</h5>
                        </div>
                        <div className={"preview-close"} onClick={() => dispatch(selectMobilePreviewGame(undefined))}>
                            <i className={"material-icons"}>close</i>
                        </div>
                    </div>
                    <div className={"game-play-button"}>
                       <span className={"click-to-play"}>
                            <i className={"material-icons"} onClick={()=> launchMobile(game, !loggedIn, history)}>play_circle_filled</i>
                        </span>
                    </div>
                    {loggedIn && hasPlayForFun && (
                        <div className={"play-for-fun"}>
                            <a className={"btn btn-secondary small"} onClick={()=> launchMobile(game, true, history)}>Play for fun</a>
                        </div>
                    )}
                </div>
            </div>
       </CSSTransition>
    )
}